import { render } from "./Compliances.vue?vue&type=template&id=1c8cfa20"
import script from "./Compliances.vue?vue&type=script&lang=js"
export * from "./Compliances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__